export default __webpack_public_path__ + "static/media/AR.a5400590.mp4";